import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const LinkTemplateComposer = lazy(() =>
  import("@scenes/MessageComposition/Email/LinkTemplates/LinkTemplateComposer").then((module) => ({
    default: module.LinkTemplateComposer,
  }))
);

export const engagementTemplatesAndMediaLinkTemplatesIdNRO: NavigationRoutingObject = {
  Component: LinkTemplateComposer,
  componentFeatureFlippers: ["link_templates_nro_component"],
  noKnockoutFallback: true,
  section: "templates",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("engagement-templates-and-media-link-templates-id-nro-heading", "Edit Link Template"),
  pageNameForTracking: () => "Edit Link Template",
  icon: "nav-system-email-link-templates",
  // Gate on the feature only, not the permission. A developer without viewLinkTemplates should see
  // NoPermissionView inside the composer (rendered when `noPermission`, matching the list NRO) rather
  // than being bounced to the dashboard home by BrazeRoute's not-allowed redirect. The data endpoint
  // (link_template_data) still enforces VIEW_LINK_TEMPLATES, so no template data is exposed; view-only
  // developers still get the read-only composer with the save/duplicate footer hidden.
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("link_templating");
  },
  // Hide the tertiary navigation for developers without view permission, so a direct /edit/:id URL
  // shows only NoPermissionView with no lingering tab -- matching the list NRO. The edit path is in
  // the linkTemplates routing group, so BrazeRoute always has a match here; returning false only hides
  // the tab (no undefined-match crash like the legacy list-redirect path had).
  shouldShowTertiaryNavigationCallback: ({ hasPermission }) => {
    return hasPermission("appGroupOrAnyTeamInAppGroup", { permission: "viewLinkTemplates" });
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
